import { createContext, useContext } from 'react';

export const CompatibilityPathnameContext = createContext<string>('');

export function useCompatibilityPathname() {
  return useContext(CompatibilityPathnameContext);
}
